import { Box, Stack, Text, Divider, Button, List, ListItem } from '@chakra-ui/react'
import { withPage } from '@/features/layout'
import { Transaction } from '../../types'

import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

type Props = {
  transaction: Transaction
}

function BankTransferDetailPage(props: Props) {
  const { transaction } = props

  const { i18n } = useTranslation()
  const packageName = transaction?.metadata?.package_name || 'small'
  const dueDate = dayjs().add(packageName === 'large' ? 7 : 14, 'day')
  const formattedDueDate = dueDate.locale(i18n.language).format('DD/MM/YYYY')

  return (
    <Box
      sx={{
        p: 8,
        borderTop: '1px solid',
        borderColor: 'brand.25',
        maxW: '520px',
        mx: 'auto',
      }}
      bg='white'
      mt={4}
      p={8}
      borderRadius="md"
    >
      <Stack spacing={6}>
        <Text fontSize="xl" fontWeight="bold">
          รายละเอียดบัญชีสำหรับการโอนเงิน
        </Text>

        <Box bg="gray.50" p={6} borderRadius="md">
          <Stack spacing={3}>
            <Text fontSize="sm" color="gray.500">
              Amount to transfer
            </Text>
            <Text fontSize="2xl" fontWeight="bold">
              {(transaction?.amount || 0).toLocaleString()} THB
            </Text>

            <Divider />

            <Text fontSize="sm" color="gray.500">
              Bank
            </Text>
            <Text>Kasikorn Bank</Text>

            <Text fontSize="sm" color="gray.500">
              Account Name
            </Text>
            <Text>บจก.เดต้า ว้าว : (DATAWOW CO.,LTD.)</Text>

            <Text fontSize="sm" color="gray.500">
              Account Number
            </Text>
            <Text fontWeight="semibold">0093749804</Text>
          </Stack>
        </Box>

        <Stack spacing={3}>
          <Text fontSize="sm" fontWeight="bold">
            ส่งหลักฐานการโอนเงิน
          </Text>

          <List spacing={1} fontSize="sm" color="gray.600" styleType="disc" pl={4}>
            <ListItem>
              กรุณาส่งหลักฐานการโอนเงินมาที่{' '}
              <Text as="a" href="mailto:sales@mail.com" color="blue.500" display="inline">
                sales@datawow.io
              </Text>
            </ListItem>

            <ListItem>
              หากไม่ได้รับหลักฐานการชำระเงินภายใน <Text as="span" fontWeight="medium">{formattedDueDate}</Text>{' '}
              ระบบจะทำการระงับการใช้งาน Package ของท่านอัตโนมัติ
            </ListItem>
          </List>

          <Text fontSize="sm" fontWeight="bold" pt={2}>
            กรุณาชำระเงิน และส่งหลักฐานการชำระเงินภายในระยะเวลาที่กำหนดของ Package
          </Text>

          <List spacing={1} fontSize="sm" color="gray.600" styleType="disc" pl={4}>
            <ListItem>
              หลังจากตรวจสอบการจ่ายเงินเรียบร้อยแล้ว ทีมงานจะส่งใบแจ้งหนี้ ใบเสร็จ
              และใบกำกับภาษี ไปให้ทางอีเมล ภายใน 3 วันทำการ
            </ListItem>
          </List>
        </Stack>

        <Button
          bg="brand.600"
          size="lg"
          width="full"
          onClick={() => window.location.href = '/transactions'}
        >
          ดำเนินการเสร็จสิ้น
        </Button>
      </Stack>
    </Box>
  )
}

export default withPage(BankTransferDetailPage)
